/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Waldorfschule2Inputs */

const en__field__enum_schoolname_waldorfschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Waldorfschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field__enum_schoolname_waldorfschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Waldorfschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waldorfschule`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field__Enum_Schoolname_Waldorfschule2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_waldorfschule2 = /** @type {((inputs?: _Field__Enum_Schoolname_Waldorfschule2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Waldorfschule2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_waldorfschule2(inputs)
	return de__field__enum_schoolname_waldorfschule2(inputs)
});
export { _field__enum_schoolname_waldorfschule2 as "_field__enum_schoolName_Waldorfschule" }